import { LeaderboardDataContext } from "contexts/LeaderboardDataContext";
import { getQueryDateString } from "helpers/date";
import { useContext, useEffect } from "react";
import API from "services/Api";

const { default: useLeaderboardProps } = require("hooks/useLeaderboardProps");
const { default: LeaderboardReports } = require("./Reports");
const { default: RankingLists } = require("./RankingLists");

const LeaderboardView = () => {
  const { startDate, endDate, viewType, isLoading, setLoading } =
    useLeaderboardProps();
  const {
    updateReportDetails,
    updateLeaderboardTotals
  } = useContext(LeaderboardDataContext);
 const fetchAssigneeFlaggedLabor = (start, end) => {
   API.getData(
     "Leaderboard",
     "GetLaborFlagsByAssignee",
     `startDate=${getQueryDateString(start)}&endDate=${getQueryDateString(end)}`
   ).then((res) => {
     updateReportDetails(res);
   });
 };
 const fetchLeaderboardTotals = (start, end) => {
   API.getData(
     "Leaderboard",
     "GetLeaderboardTotals",
     `startDate=${getQueryDateString(start)}&endDate=${getQueryDateString(end)}`
   ).then((res) => {
     updateLeaderboardTotals(res);
   });
 };

  const fetchAllData = async (start, end, viewType) => {
    const fetchRankingsPromises = [
      fetchLeaderboardTotals(start, end),
    ];

    const fetchReportPromises = [fetchAssigneeFlaggedLabor(start, end)];

    const fetchPromises = viewType === "rank" ? fetchRankingsPromises : fetchReportPromises;

    try {
      await Promise.all(fetchPromises);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
  setLoading(true)
    fetchAllData(startDate, endDate, viewType);
  }, [startDate, endDate, viewType]);

  useEffect(() => {
    const jobDirtyEvent = (e) => {
      setLoading(true)
      fetchAllData(startDate, endDate, viewType)
      console.log("job dirty event from leaderboard view");
    };
    window.addEventListener("jobUpdate", jobDirtyEvent);
    window.addEventListener("addNewJob", jobDirtyEvent);
    window.addEventListener("removeJob", jobDirtyEvent);
    window.addEventListener("jobFolder-update", jobDirtyEvent);
    return () => {
      window.removeEventListener("jobUpdate", jobDirtyEvent);
      window.removeEventListener("addNewJob", jobDirtyEvent);
      window.removeEventListener("removeJob", jobDirtyEvent);
      window.removeEventListener("jobFolder-update", jobDirtyEvent);
    };
  }, [startDate, endDate, viewType]);

  return (
    <>
      {viewType === "rank" ? (
        <RankingLists />
      ) : (
        <LeaderboardReports />
      )}
    </>
  );
};

export default LeaderboardView;
